import { useState } from 'react';
import { MagneticCta } from '../components/MagneticCta';
import { siteConfig } from '../../../shared/config/site';

export function VisitSection() {
  const [mapLoaded, setMapLoaded] = useState(false);

  return (
    <section id="visit" className="relative bg-paper py-[var(--section-padding-y)]" aria-labelledby="visit-heading">
      <div className="mx-auto grid max-w-[var(--container-max)] grid-cols-1 gap-12 px-[var(--section-padding-x)] lg:grid-cols-2 lg:gap-20">
        <div>
          <p className="section-eyebrow">Visit</p>
          <h2 id="visit-heading" className="section-title">
            Moray Drive, Bryanston
          </h2>
          <p className="section-copy max-w-lg">
            Pull into 1 Moray Dr when you need a consult, a follow-up, or a calm room for a nervous cat. The team picks
            up the phone during clinic hours.
          </p>

          <dl className="mt-10 space-y-6 font-body text-neutral-600">
            <div>
              <dt className="text-xs uppercase tracking-[0.25em] text-neutral-500">Address</dt>
              <dd className="mt-2 text-lg text-ink">{siteConfig.addressLine}</dd>
            </div>
            <div>
              <dt className="text-xs uppercase tracking-[0.25em] text-neutral-500">Phone</dt>
              <dd className="mt-2">
                <a
                  href={siteConfig.phoneHref}
                  className="inline-flex min-h-[44px] items-center text-lg text-primary-600 hover:text-primary-500"
                >
                  {siteConfig.phoneDisplay}
                </a>
              </dd>
            </div>
            <div>
              <dt className="text-xs uppercase tracking-[0.25em] text-neutral-500">Email</dt>
              <dd className="mt-2">
                <a
                  href={siteConfig.emailHref}
                  className="inline-flex min-h-[44px] items-center text-lg text-primary-600 hover:text-primary-500"
                >
                  {siteConfig.email}
                </a>
              </dd>
            </div>
          </dl>

          <div className="mt-10 flex flex-wrap gap-4">
            <MagneticCta href={siteConfig.phoneHref} variant="primary">
              Call now
            </MagneticCta>
            <MagneticCta href={siteConfig.mapsUrl} variant="ghost">
              Open in Google Maps
            </MagneticCta>
          </div>
        </div>

        <div className="relative aspect-[4/3] min-h-[280px] overflow-hidden rounded-3xl border border-neutral-200 bg-stage">
          {mapLoaded ? (
            <iframe
              title="Bryanpark Veterinary Clinic on Google Maps"
              src="https://maps.google.com/maps?q=Bryanpark+Veterinary+Clinic,+1+Moray+Dr,+Bryanston&t=&z=15&ie=UTF8&iwloc=&output=embed"
              className="h-full w-full border-0 grayscale-[20%] contrast-[1.02]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          ) : (
            <button
              type="button"
              onClick={() => setMapLoaded(true)}
              className="group absolute inset-0 flex flex-col items-center justify-center gap-4 text-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-primary-400"
            >
              <span className="stage-frame-inner" aria-hidden="true" />
              <span className="relative font-display text-2xl font-semibold text-mist">
                1 Moray Drive
              </span>
              <span className="relative inline-flex min-h-[48px] items-center rounded-lg border border-[rgba(126,184,176,0.45)] px-6 font-body text-sm font-medium text-mist transition-colors group-hover:border-primary-300 group-hover:bg-[rgba(6,41,39,0.55)]">
                Load the map
              </span>
              <span className="relative max-w-[26ch] font-body text-xs leading-5 text-neutral-300">
                Loads Google Maps only when you ask for it.
              </span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
